module.exports = __webpack_public_path__ + "img/kjsy_gallery0.69c0d6f1.jpg";